// extracted by mini-css-extract-plugin
export default {"main":"ClientPanelCardHeader_main__WtoGm","collapsed":"ClientPanelCardHeader_collapsed__Tud+F"};